import { render } from "./HotelSearch.vue?vue&type=template&id=6736f610"
import script from "./HotelSearch.vue?vue&type=script&lang=js"
export * from "./HotelSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__